import { TFunction } from 'i18next';
import { WfFloodCategoryStatus } from './WfFloodCategoryStatus';

export enum WfFloodLocation {
  Pit = 'Pit',
  CarriageRound = 'CarriageRound',
  Platform = 'Platform',
  MachineRoom = 'MachineRoom',
  Tower = 'Tower',
  UpperMachineRoom = 'UpperMachineRoom',
  LowerMachineRoom = 'LowerMachineRoom',
  Handrails = 'Handrails',
  Chains = 'Chains',
  Steps = 'Steps',
  AutomaticDoors = 'AutomaticDoors',
  SecurityCameras = 'SecurityCameras',
  SurveillanceEquipment = 'SurveillanceEquipment',
  WaterTanks = 'WaterTanks',
  Boilers = 'Boilers',
  HeatSourceEquipment = 'HeatSourceEquipment',
  AncillaryEquipment = 'AncillaryEquipment',
  PowerDistributionPanels = 'PowerDistributionPanels',
  Others = 'Others',
}

export const WfFloodLocationMapping = (t: TFunction) => ({
  [WfFloodLocation.Pit]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.pit') ?? '',
    value: WfFloodLocation.Pit,
  },
  [WfFloodLocation.CarriageRound]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.carriageRound'),
    value: WfFloodLocation.CarriageRound,
  },
  [WfFloodLocation.Platform]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.platform'),
    value: WfFloodLocation.Platform,
  },
  [WfFloodLocation.MachineRoom]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.machineRoom'),
    value: WfFloodLocation.MachineRoom,
  },
  [WfFloodLocation.Tower]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.tower'),
    value: WfFloodLocation.Tower,
  },
  [WfFloodLocation.UpperMachineRoom]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.upperMachineRoom'),
    value: WfFloodLocation.UpperMachineRoom,
  },
  [WfFloodLocation.LowerMachineRoom]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.lowerMachineRoom'),
    value: WfFloodLocation.LowerMachineRoom,
  },
  [WfFloodLocation.Handrails]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.handrails'),
    value: WfFloodLocation.Handrails,
  },
  [WfFloodLocation.Chains]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.chains'),
    value: WfFloodLocation.Chains,
  },
  [WfFloodLocation.Steps]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.steps'),
    value: WfFloodLocation.Steps,
  },
  [WfFloodLocation.AutomaticDoors]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.automaticDoors'),
    value: WfFloodLocation.AutomaticDoors,
  },
  [WfFloodLocation.SecurityCameras]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.securityCameras'),
    value: WfFloodLocation.SecurityCameras,
  },
  [WfFloodLocation.SurveillanceEquipment]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.suveilanceEquipment'),
    value: WfFloodLocation.SurveillanceEquipment,
  },
  [WfFloodLocation.WaterTanks]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.waterTanks'),
    value: WfFloodLocation.WaterTanks,
  },
  [WfFloodLocation.Boilers]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.boilers'),
    value: WfFloodLocation.Boilers,
  },
  [WfFloodLocation.HeatSourceEquipment]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.heatSourceEquipment'),
    value: WfFloodLocation.HeatSourceEquipment,
  },
  [WfFloodLocation.AncillaryEquipment]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.ancillaryEquipment'),
    value: WfFloodLocation.AncillaryEquipment,
  },
  [WfFloodLocation.PowerDistributionPanels]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.powerDistributionPanels'),
    value: WfFloodLocation.PowerDistributionPanels,
  },
  [WfFloodLocation.Others]: {
    title: t('wf.statusInformationRegistration.floodedAreaOptions.others'),
    value: WfFloodLocation.Others,
  },
});

export const getFloodLocationOptions = (
  classificationStatus: WfFloodCategoryStatus | null,
  t: TFunction
) => {
  switch (classificationStatus) {
    case WfFloodCategoryStatus.EL:
      return Object.values(WfFloodLocationMapping(t)).filter((item) =>
        [
          WfFloodLocation.Pit,
          WfFloodLocation.CarriageRound,
          WfFloodLocation.Platform,
          WfFloodLocation.MachineRoom,
          WfFloodLocation.Tower,
        ].includes(item.value)
      );
    case WfFloodCategoryStatus.ES:
      return Object.values(WfFloodLocationMapping(t)).filter((item) =>
        [
          WfFloodLocation.UpperMachineRoom,
          WfFloodLocation.LowerMachineRoom,
          WfFloodLocation.Handrails,
          WfFloodLocation.Chains,
          WfFloodLocation.Steps,
        ].includes(item.value)
      );
    case WfFloodCategoryStatus.Building:
      return Object.values(WfFloodLocationMapping(t)).filter((item) =>
        [
          WfFloodLocation.AutomaticDoors,
          WfFloodLocation.SecurityCameras,
          WfFloodLocation.SurveillanceEquipment,
          WfFloodLocation.WaterTanks,
          WfFloodLocation.Others,
        ].includes(item.value)
      );
    case WfFloodCategoryStatus.HeatingCooling:
      console.log(WfFloodLocationMapping(t));
      return Object.values(WfFloodLocationMapping(t)).filter((item) =>
        [
          WfFloodLocation.Others,
          WfFloodLocation.HeatSourceEquipment,
          WfFloodLocation.AncillaryEquipment,
          WfFloodLocation.PowerDistributionPanels,
        ].includes(item.value)
      );
    default:
      return [];
  }
};

export const getDefaultFloodLocation = (category: WfFloodCategoryStatus): WfFloodLocation => {
  switch (category) {
    case WfFloodCategoryStatus.EL:
      return WfFloodLocation.Pit;
    case WfFloodCategoryStatus.ES:
      return WfFloodLocation.UpperMachineRoom;
    case WfFloodCategoryStatus.Building:
      return WfFloodLocation.AutomaticDoors;
    case WfFloodCategoryStatus.HeatingCooling:
      return WfFloodLocation.HeatSourceEquipment;
    default:
      return WfFloodLocation.Pit;
  }
};
